import { createSelector } from "@ngrx/store";
import { MediaState, selectMediaEntities, selectMediaState } from "./media.reducer";
import { MediaModel } from "../models";
import { selectIdFromUrl } from "libs/tm-common/src/lib/store/selectors";

export const selectMediaById = (id: string) =>
	createSelector(selectMediaEntities, (mediaEntities) => mediaEntities[id]);

/**
 * Selects *only* the media files attached to this treatment
 * (does not include media files of associated treatments)
 */
export const selectMediaOfCurrentTreatment = createSelector(
	selectIdFromUrl,
	selectMediaEntities,
	(treatmentId, entities) => {
		const mediaEntities: MediaModel[] = Object.values(entities);
		return mediaEntities.filter(
			(medium) => medium.treatment === treatmentId || (treatmentId == null && medium.treatment == null)
		);
	}
);

export const selectFilesInUpload = createSelector(
	selectMediaState,
	(state: MediaState) => state.filesInUpload
);
